import { Link } from "react-router-dom";

export default function Logo({ light = false }) {
  return (
    <Link to="/" className="flex items-center" data-testid="nav-logo">
      <img
        src="/tf-logo.png"
        alt="Technofocus"
        style={{
          height: 38,
          width: "auto",
          filter: light ? "brightness(0) invert(1)" : "none",
          transition: "filter 0.3s",
        }}
      />
    </Link>
  );
}
